var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer_box mt5",attrs:{"id":"id_foot"}},[_c('router-link',{attrs:{"to":"/about"}},[_c('p',{staticClass:"p_foot_str"},[_vm._v("About")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }